import { useMemo, useRef } from "react"

import { useFormSubmit } from "shared/lib/useFormSubmit"
import { FormRef } from "shared/types/ReactHookForm"

import { useTeamRoleOptions } from "entities/teams/model/useTeamRoleOptions"
import { CreateTeamMemberFormData } from "features/team-member-management/types/CreateTeamMemberFormData"
import { CreateTeamMemberFormModel } from "features/team-member-management/ui/create-team-member-form"

import { ManageProjectTeamOverlayProps } from "../ManageProjectTeamOverlay"
import { ManageProjectTeamOverlayViewModel } from "../ui/ManageProjectTeamOverlayView"

export function useManageTeamOverlayViewModel({
  projectID,
  onSubmit,
  currentUserEmail,
  existingTeamMemberEmails,
  ...rest
}: ManageProjectTeamOverlayProps): ManageProjectTeamOverlayViewModel {
  const formRef: FormRef<CreateTeamMemberFormData> = useRef(null)
  const roleOptions = useTeamRoleOptions()

  const { handleSubmit, isSubmitting } = useFormSubmit({ onSubmit, formRef })

  const formModel = useMemo<CreateTeamMemberFormModel>(
    () => ({
      existingTeamMemberEmails,
      currentUserEmail,
      onSubmit: handleSubmit,
      formRef
    }),
    [currentUserEmail, existingTeamMemberEmails, handleSubmit, formRef]
  )

  return {
    ...rest,
    formModel,
    roleOptions,
    isSubmitting
  }
}
